var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5L5.64645 1.14645L6 0.792893L6.35355 1.14645L6 1.5ZM6.5 7C6.5 7.27614 6.27614 7.5 6 7.5C5.72386 7.5 5.5 7.27614 5.5 7L6.5 7ZM3.14645 3.64645L5.64645 1.14645L6.35355 1.85355L3.85355 4.35355L3.14645 3.64645ZM6.35355 1.14645L8.85355 3.64645L8.14645 4.35355L5.64645 1.85355L6.35355 1.14645ZM6.5 1.5L6.5 7L5.5 7L5.5 1.5L6.5 1.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5L5.64645 10.8536L6 11.2071L6.35355 10.8536L6 10.5ZM6.5 7C6.5 6.72386 6.27614 6.5 6 6.5C5.72386 6.5 5.5 6.72386 5.5 7L6.5 7ZM3.14645 8.35355L5.64645 10.8536L6.35355 10.1464L3.85355 7.64645L3.14645 8.35355ZM6.35355 10.8536L8.85355 8.35355L8.14645 7.64645L5.64645 10.1464L6.35355 10.8536ZM6.5 10.5L6.5 7L5.5 7L5.5 10.5L6.5 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.07c8b91e1ea0fcc9007da36bf6f1878b.svg";
export { ForwardRef as ReactComponent };